<template>
    <div>
        <dx-grid
            url="cholHamoedProgramReports"
            :columns="columns"
            :title="title"
            :actions="actions"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="drawWinnerDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline pl-0 py-2"
                    >Draw A Winner</v-card-title
                >
                <div style="overflow-y: auto; height: 300px">
                    <div
                        v-for="student in students"
                        style="border: 1px solid #eee;"
                        class="px-2 mb-2"
                    >
                        <div class="mb-2">
                            <div class="pt-2 font-weight-medium">
                                {{ student.nameH + " - " + student.name }}
                            </div>
                        </div>
                        <v-layout row>
                            <div class="pb-2 mr-3">
                                Digit: {{ student.digit }}
                            </div>
                            <div>Expense: {{ student.expense | currency }}</div>
                        </v-layout>
                    </div>
                </div>
                <v-card-actions class="mx-0 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="drawWinnerDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="draw()"
                        :disabled="ifWinner()"
                        >draw</v-btn
                    ><v-spacer></v-spacer>
                </v-card-actions>

                <v-layout column justify-center align-center>
                    <div v-if="winner" class="title">Winner: {{ winner }}</div>
                    <v-btn
                        v-if="winner"
                        small
                        class="mt-0"
                        @click="removeWinner"
                        color="success"
                        >Remove & Retry</v-btn
                    >
                </v-layout>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deleteDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Reports</v-card-title
                >
                <div class="font-weight-regular">
                    The {{ selected.length }} selected will be deleted
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteReports"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { formatCurrency, groupBy } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Chol Hamoed Program Reports",
        actions: [],
        drawWinnerDialog: false,
        processing: false,
        students: [],
        selected: [],
        winner: "",
        deleteDialog: false,

        columns: [
            {
                label: "Yiddish Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "weeks")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
                visible: true,
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Digit",
                field: "digit",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Expense",
                field: "expense",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Program Name",
                field: "programName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastUpdated",
                label: "Last Updated",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.actions.push({
            text: "Delete",
            action: this.openDeleteDialog,
            showOnSelection: true,
        });

        this.actions.push({
            text: "Draw a Winner",
            action: this.drawWinner,
            showOnSelection: true,
        });
    },
    methods: {
        openDeleteDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.deleteDialog = true;
        },
        async deleteReports() {
            try {
                const ids = this.selected.map((s) => s.id);

                this.processing = true;

                await this.$http.post(
                    "api/cholHamoedProgramReports/delete",
                    ids,
                );

                this.processing = false;
                this.deleteDialog = false;

                this.$notify({
                    group: "notification",
                    text: ids.length + " Deleted",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        drawWinner() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.winner = "";

            const group = groupBy(this.selected, "studentID");

            this.students = Object.keys(group).map((key) => {
                return group[key][0];
            });

            this.drawWinnerDialog = true;
        },
        ifWinner() {
            return !!this.winner;
        },
        draw() {
            let randomIndex = Math.floor(Math.random() * this.students.length);

            let winner = this.students[randomIndex];

            this.winner =
                winner.studentID +
                " - " +
                winner.nameH +
                " (" +
                winner.class +
                "|" +
                winner.section +
                ")";
        },
        removeWinner() {
            this.winner = "";
        },
    },
};
</script>
<style></style>
